"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popoverMaxHeightVariant = exports.listTheme = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const component_theme_1 = require("@clds/component-theme");
exports.listTheme = (0, component_theme_1.createTheme)({
    byMaxHeight: {
        md: { maxHeight: '300px' },
        lg: { maxHeight: '420px' },
        none: { maxHeight: 'none' },
    },
}, 'list');
exports.popoverMaxHeightVariant = (0, component_theme_1.createVariant)(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => exports.listTheme.byMaxHeight[props.maxHeight || 'none']);
//# sourceMappingURL=theme.js.map